import ApiService from '@/shared/services/api.service';

const ID_BATCH_SIZE = 10;

export class FormsService {
    static list(params) {
        return new Promise((resolve, reject) => {
            ApiService.query('/forms', params)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    static find(id) {
        return new Promise((resolve, reject) => {
            ApiService.get(`/forms/${id}`)
                .then((response) => resolve(response))
                .catch((error) => reject(error));
        });
    }

    static create(data) {
        return new Promise((resolve, reject) => {
            ApiService.post( '/forms', { ...data } )
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    static update(id, data) {
        return new Promise((resolve, reject) => {
            ApiService.patch(`/forms/${id}`, { ...data })
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    static async remove(id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`/forms/${id}`)
                .then(() => resolve())
                .catch((error) => {
                    reject(error);
                });
        });
    }

    static async listAutocomplete() {
        const response = await ApiService.get('/forms?limit=500&fields=id,name');
        return response?.data?.data || [];
    }

    // Batches ids to keep query strings short and avoids one request per id
    static async findByIds(ids) {
        const uniqueIds = [...new Set(ids)].filter(Boolean);
        if (uniqueIds.length === 0) return [];

        const chunks = [];
        for (let i = 0; i < uniqueIds.length; i += ID_BATCH_SIZE) {
            chunks.push(uniqueIds.slice(i, i + ID_BATCH_SIZE));
        }

        const results = [];
        for (const chunk of chunks) {
            const response = await ApiService.query('/forms', {
                params: { query: `_id in ${chunk.join(',')}`, limit: chunk.length, pagination: true },
            });
            results.push(...(response?.data?.data || response?.data || []));
        }

        return results;
    }
}
